import React from 'react'

function Title() {
    return (
        <div className='alltitle'>
            <h1><span className='A'>A</span>rmadillos</h1>
        </div>
    )
}
export default Title